let _ = t => t,
  _t;
import _styled from "styled-components";
import I18n from 'I18n';
import { useSelector } from 'react-redux';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { FieldVisibilityControlsWrapper } from './FieldVisibilityControls';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { getForwardCommunicatorState } from 'composer-data/email/public/selectors';
// @ts-expect-error module not typed
import { getInReplyToId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
import { CALYPSO, EERIE } from 'HubStyleTokens/colors';
import { getRecipientsIconName } from '../operators/getRecipientsIconName';
import MetadataInputLabel from './MetadataInputLabel';
import EmailTagDisplayBar from './EmailTagDisplayBar';
import { RecipientTagDisplayBar } from './RecipientTagDisplayBar';
import { RecipientTooltipTitle } from './RecipientTooltipTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CollapsedInputWrapper = styled.label.withConfig({
  displayName: "CollapsedMetadataEditor__CollapsedInputWrapper",
  componentId: "sc-1pknl1t-0"
})(["display:inline-flex;flex-grow:1;width:90%;"]);
export const CollapsedMetadataEditor = ({
  allRecipients,
  handleMoreButtonOnClick,
  handleSetExpanded,
  reply,
  toLabel,
  onChange,
  showSenderSubjectFields,
  useWhatsAppCompose
}) => {
  const MAX_RECIPIENTS_TO_SHOW_IN_COLLAPSED_METADATA = 2;
  const {
    replyAll
  } = useSelector(getForwardCommunicatorState);
  const commonMessageReply = getCommonMessage(reply);
  const inReplyToId = getInReplyToId(commonMessageReply);
  const iconName = getRecipientsIconName({
    allRecipients,
    commonMessageReply,
    replyAll
  });
  const verticalMenuTooltip = showSenderSubjectFields ? I18n.text('composer-ui.metadata-editor.collapsed-metadata-editor.hide-sender-and-subject') : I18n.text('composer-ui.metadata-editor.collapsed-metadata-editor.edit-sender-and-subject');
  const buttonTestId = showSenderSubjectFields ? 'metada-expand-button-collapse' : 'metada-expand-button-expand';
  const fieldVisibilityControls = /*#__PURE__*/_jsx(FieldVisibilityControlsWrapper, {
    children: /*#__PURE__*/_jsx(UIIconButton, {
      onClick: handleMoreButtonOnClick,
      placement: "top",
      tooltip: verticalMenuTooltip,
      use: "link",
      "data-selenium-test": buttonTestId,
      children: /*#__PURE__*/_jsx(_StyledUIIcon, {
        name: "verticalMenu",
        size: "small",
        className: "m-right-0",
        color: EERIE
        // @ts-expect-error legacy
      })
    })
  });
  const DisplayBarComponent = useWhatsAppCompose ? /*#__PURE__*/_jsx(RecipientTagDisplayBar, {
    allRecipients: allRecipients,
    multiCollapseLimit: MAX_RECIPIENTS_TO_SHOW_IN_COLLAPSED_METADATA,
    onClick: handleSetExpanded,
    onChange: onChange,
    reply: reply
  }) : /*#__PURE__*/_jsx(EmailTagDisplayBar, {
    clearableValues: false,
    allRecipients: allRecipients,
    multiCollapseLimit: MAX_RECIPIENTS_TO_SHOW_IN_COLLAPSED_METADATA,
    onClick: handleSetExpanded,
    onChange: onChange,
    commonMessageReply: commonMessageReply
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [inReplyToId && iconName ? /*#__PURE__*/_jsxs(CollapsedInputWrapper, {
      "data-selenium-test": "metadata-to-input",
      children: [/*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(RecipientTooltipTitle, {
          iconName: iconName
        }),
        placement: "bottom",
        children: /*#__PURE__*/_jsx(UIIcon, {
          "data-selenium-test": "metadata-to-icon",
          name: iconName,
          style: {
            display: 'inline-flex',
            alignItems: 'center',
            marginRight: 8,
            marginTop: 4
          },
          size: 24
        })
      }), DisplayBarComponent]
    }) : /*#__PURE__*/_jsx(MetadataInputLabel, {
      label: toLabel,
      "data-selenium-test": "metadata-to-input",
      children: DisplayBarComponent
    }), fieldVisibilityControls]
  });
};
CollapsedMetadataEditor.displayName = 'CollapsedMetadataEditor';
var _StyledUIIcon = _styled(UIIcon)(_t || (_t = _`
            :hover {
              color: ${0} !important;
            }
          `), CALYPSO);